const swagger = {
    invalid_zod_type: 'Неверный тип Zod. Пожалуйста, проверьте конфигурацию защиты маршрута.',
    not_supported_zod_type_for_params: 'Неподдерживаемый тип Zod для параметров. Пожалуйста, проверьте конфигурацию защиты маршрута.',
};
export default Object.freeze(swagger);
